import { type UserType } from '@kijiji/generated/graphql-types'

import { FORM_FIELDS } from '@/components/vip/vip-trade-in/constants/vipTradeIn'
import { isNpvDealer } from '@/features/profile/utils/isNpvDealer'

/**
 * Retrieves the default form values based on the buyer's email address and seller's user type.
 * The function will conditionally include additional fields for either PV or NPV dealers.
 *
 * @param userEmail - The email address of the buyer. This will be used to set the default value for the email field.
 * @param userType - The type of user (e.g., PV or NPV). Determines which set of default values to include.
 * @returns An object containing the default form values for the user's form.
 */
export const getDefaultFormValues = (userEmail: string | undefined | null, userType: UserType) => {
  const defaultFormValues = {
    [FORM_FIELDS.EMAIL]: userEmail ?? '',
    [FORM_FIELDS.FIRST_NAME]: '',
    [FORM_FIELDS.LAST_NAME]: '',
    [FORM_FIELDS.MAKE]: '',
    [FORM_FIELDS.MILEAGE]: '',
    [FORM_FIELDS.PHONE]: '',
    [FORM_FIELDS.YEAR]: '',
  }

  // Define default values for npv (Non-PV) and pv (PV) based on user type
  const npvDefaultValues = {
    [FORM_FIELDS.VEHICLE_TYPE]: '',
  }

  const pvDefaultValues = {
    [FORM_FIELDS.MODEL]: '',
  }

  if (isNpvDealer(userType)) {
    return { ...defaultFormValues, ...npvDefaultValues }
  }

  return { ...defaultFormValues, ...pvDefaultValues }
}
